import { ShowWithTixologiEvent } from "./shows";
import { VenuePagesRow } from "./venue_pages";
import { VenueRow } from "./venues";
import dayjs from "@punchup/utils/dayjs";

export interface TourDatesClientProps {
  venuePage: VenuePagesRow;
  locations: Partial<VenueRow>[] | null;
}

export type SortColumn = "show" | "date" | "tickets" | "state";

export interface ShowsFilterState {
  search: string;
  orderBy: "newest" | "oldest";
  dateRange: {
    start: string | null;
    end: string | null;
  };
  state: {
    published: boolean;
    draft: boolean;
    finished: boolean;
  };
  tickets: {
    ticketsAdded: boolean;
    missingTickets: boolean;
  };
  lineup: {
    lineupAdded: boolean;
    noLineup: boolean;
  };
}

export enum TixologiEventAction {
  DUPLICATE = "duplicate",
  EDIT = "edit",
  DELETE = "delete",
  DOWNLOAD_QR = "download-qr",
  COMPED_TICKETS_CSV = "comped-tickets-csv",
}

export interface DuplicateEventData {
  startDate?: string;
  name?: string;
  doorTimeOffset?: string;
  ticketTypes?: {
    id: number;
    onSaleDateTime?: string;
    offSaleDateTime?: string;
  }[];
}

export interface ActionModalProps {
  show: ShowWithTixologiEvent;
  eventAction: TixologiEventAction | undefined;
  setEventAction: (action: TixologiEventAction | undefined) => void;
  isPerformingAction: boolean;
  handleEventAction: (data?: DuplicateEventData) => void;
}

export const filterShows = (
  shows: ShowWithTixologiEvent[],
  activeFilters: ShowsFilterState
): ShowWithTixologiEvent[] => {
  let filtered = [...shows];

  if (
    activeFilters.state.published ||
    activeFilters.state.draft ||
    activeFilters.state.finished
  ) {
    filtered = filtered.filter((show) => {
      const isFinished = show.event?.end_date
        ? dayjs(show.datetime).isBefore(dayjs())
        : null;
      const hasTickets = !!show.ticket_link;
      const isPublished = hasTickets && !isFinished;
      const isDraft = !hasTickets && !isFinished;

      return (
        (activeFilters.state.published && isPublished) ||
        (activeFilters.state.draft && isDraft) ||
        (activeFilters.state.finished && isFinished)
      );
    });
  }

  if (
    activeFilters.tickets.ticketsAdded ||
    activeFilters.tickets.missingTickets
  ) {
    filtered = filtered.filter((show) => {
      const hasTickets = !!show.event?.ticket_types?.length;
      return (
        (activeFilters.tickets.ticketsAdded && hasTickets) ||
        (activeFilters.tickets.missingTickets && !hasTickets)
      );
    });
  }

  if (activeFilters.lineup.lineupAdded || activeFilters.lineup.noLineup) {
    filtered = filtered.filter((show) => {
      const hasLineup = show.show_comedians && show.show_comedians.length > 0;
      return (
        (activeFilters.lineup.lineupAdded && hasLineup) ||
        (activeFilters.lineup.noLineup && !hasLineup)
      );
    });
  }

  return filtered;
};
